module.exports = __webpack_public_path__ + "static/app-store-button-6b1919b7d8fecec3dc320e58fff1a4b2.svg";